import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53530027"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = ["aria-label", "id"]
const _hoisted_3 = {
  key: 0,
  class: "warning-row"
}
const _hoisted_4 = {
  id: "illegal-units",
  colspan: "5"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_6 = { class: "bg-white row-one-headers" }
const _hoisted_7 = ["aria-label", "id"]
const _hoisted_8 = {
  key: 0,
  class: "overflow-menu overflow-menu--open-left"
}
const _hoisted_9 = ["data-js-target"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  fill: "white",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#more-vert" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "overflow-list" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" })
], -1))
const _hoisted_18 = { class: "row-one-data" }
const _hoisted_19 = ["headers", "data-cy-inner", "data-cy-id"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = { class: "bg-alternative row-two-headers" }
const _hoisted_22 = ["headers"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_24 = {
  key: 0,
  class: "bg-alternative row-two-data"
}
const _hoisted_25 = ["headers", "data-cy-id"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_27 = {
  key: 1,
  class: "bg-alternative row-two-data"
}
const _hoisted_28 = ["headers", "data-cy-id"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_30 = {
  key: 2,
  class: "bg-white row-two-headers"
}
const _hoisted_31 = ["headers"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_33 = {
  key: 3,
  class: "bg-white row-two-data"
}
const _hoisted_34 = ["headers", "data-cy-id"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_36 = {
  key: 4,
  class: "bg-alternative row-two-data"
}
const _hoisted_37 = {
  colspan: "5",
  style: {"padding":"0"}
}
const _hoisted_38 = { class: "accordion" }
const _hoisted_39 = { style: {"margin":"0"} }
const _hoisted_40 = ["aria-controls", "aria-expanded"]
const _hoisted_41 = ["id", "aria-hidden"]
const _hoisted_42 = { class: "flex justify-content-center remarks-and-files" }
const _hoisted_43 = {
  style: {"text-align":"left","flex-basis":"30%","word-break":"break-word"},
  "data-cy-id": "Scope3Kategori"
}
const _hoisted_44 = {
  style: {"text-align":"left","flex-basis":"40%","word-break":"break-word","white-space":"pre-line"},
  "data-cy-id": "Bemaerkninger"
}
const _hoisted_45 = {
  style: {"text-align":"left","flex-basis":"30%"},
  "data-cy-id": "Vedhaeftninger"
}
const _hoisted_46 = {
  key: 0,
  class: "file-list"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_49 = { class: "modal-content" }
const _hoisted_50 = { class: "modal-header" }
const _hoisted_51 = { class: "modal-title" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = { class: "modal-footer" }
const _hoisted_58 = {
  key: 1,
  id: "modal-backdrop",
  class: "modal-backdrop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'edit': this.getContent.isEdit})
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", {
          "aria-label": 'beregning_' + _ctx.getId,
          id: 'beregning_' + _ctx.getId,
          class: _normalizeClass(_ctx.isCopy(this.getContent) ? 'table marked-border-as-copy' : 'table')
        }, [
          _createElementVNode("thead", null, [
            (this.getContent?.showWarning)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                  _createElementVNode("th", _hoisted_4, [
                    _createVNode(_component_SimpleText, { "text-key": "warning.inputsection.illegal.units" })
                  ]),
                  _hoisted_5
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getContent?.rowColHeaders ? this.getContent.rowColHeaders[0] : _ctx.missingData, (col, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("th", {
                  key: 'header_row1_' + index,
                  "aria-label": 'Række' + (index + 1),
                  id: 'beregning-' + _ctx.getId + '-Række' + (index + 1),
                  scope: "col",
                  class: _normalizeClass({ 'empty-header': col === undefined })
                }, null, 10, _hoisted_7)), [
                  [_directive_dompurify_html, col !== undefined ? col : 'Empty-header' +'-Række' + (index + 1)]
                ])
              }), 128)),
              _createElementVNode("th", {
                scope: "col",
                class: _normalizeClass(_ctx.isCopy(this.getContent) ? 'marked-as-copy' : '')
              }, [
                (!this.getContent.readonly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("button", {
                        "data-js-target": `actions-overflow-${_ctx.getId}`,
                        "aria-expanded": "false",
                        "aria-haspopup": "true",
                        "aria-label": "Beregningsmenu",
                        class: "button-overflow-menu js-dropdown"
                      }, _hoisted_11, 8, _hoisted_9),
                      _createElementVNode("div", {
                        id: `actions-overflow-${_ctx.id}`,
                        "aria-hidden": "true",
                        class: "overflow-menu-inner"
                      }, [
                        _createElementVNode("ul", _hoisted_13, [
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit-click')))
                            }, [
                              _createVNode(_component_SimpleText, { "text-key": "sharedContent.edit" }),
                              _hoisted_14
                            ])
                          ]),
                          (_ctx.aiActive)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                _createElementVNode("button", {
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.aiClick(this.getContent)))
                                }, [
                                  _createTextVNode(" AI "),
                                  _hoisted_16
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeleteCalculation()))
                            }, [
                              _createVNode(_component_SimpleText, { "text-key": "sharedContent.delete" }),
                              _hoisted_17
                            ])
                          ])
                        ])
                      ], 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getContent.rowColData ? this.getContent.rowColData[0] : _ctx.missingData, (row, index) => {
                return (_openBlock(), _createElementBlock("td", {
                  headers: 'beregning-' + _ctx.getId + '-Række' + (index + 1),
                  "data-cy-inner": index > 0 ? _ctx.doPrettify(row, 2) : row,
                  "data-cy-id": 'Felt' + (index + 1),
                  key: 'row1-data-' + index,
                  class: _normalizeClass({ 'text-align-right': !isNaN(Number(row)) && index > 0 })
                }, _toDisplayString(index > 0 && row !== '' ? _ctx.doPrettify(this.getTranslation(row, this.getContent), 2) : this.getTranslation(row, this.getContent)), 11, _hoisted_19))
              }), 128)),
              _hoisted_20
            ]),
            _createElementVNode("tr", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getContent?.rowColHeaders ? this.getContent.rowColHeaders[1] : _ctx.missingData, (row, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("td", {
                  headers: 'beregning-' + _ctx.getId + '-Række' + (index + 1),
                  key: 'row2-' + index
                }, null, 8, _hoisted_22)), [
                  [_directive_dompurify_html, row]
                ])
              }), 128)),
              _hoisted_23
            ]),
            (_ctx.basisModule)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getContent?.rowColData ? this.getContent.rowColData[1] : _ctx.missingData, (row, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("td", {
                      headers: 'beregning-' + _ctx.getId + '-Række' + (index + 1),
                      "data-cy-id": 'Felt' + (index + 6),
                      key: 'row2-data-basis-' + index
                    }, null, 8, _hoisted_25)), [
                      [_directive_dompurify_html, row == '' ? '' : _ctx.doPrettify(row, 2) || _ctx.notRelevant]
                    ])
                  }), 128)),
                  _hoisted_26
                ]))
              : (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getContent?.rowColData ? this.getContent.rowColData[1] : _ctx.missingData, (row, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("td", {
                      headers: 'beregning-' + _ctx.getId + '-Række' + (index + 1),
                      "data-cy-id": 'Felt' + (index + 6),
                      key: 'row2-data-' + index
                    }, null, 8, _hoisted_28)), [
                      [_directive_dompurify_html, _ctx.doPrettify(row, 2) || _ctx.notRelevant]
                    ])
                  }), 128)),
                  _hoisted_29
                ])),
            (this.getContent.rowColHeaders?.[2] && !_ctx.basisModule)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getContent?.rowColHeaders ? this.getContent?.rowColHeaders[2] : _ctx.missingData, (row, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("td", {
                      headers: 'beregning-' + _ctx.getId + '-Række' + (index + 1),
                      key: 'row2-' + index
                    }, null, 8, _hoisted_31)), [
                      [_directive_dompurify_html, row]
                    ])
                  }), 128)),
                  _hoisted_32
                ]))
              : _createCommentVNode("", true),
            (this.getContent?.rowColHeaders?.[2] && !_ctx.basisModule)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getContent.rowColData ? this.getContent.rowColData[2] : _ctx.missingData, (row, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("td", {
                      headers: 'beregning-' + _ctx.getId + '-Række' + (index + 1),
                      "data-cy-id": 'Felt' + (index + 6),
                      key: 'row2-data-' + index
                    }, null, 8, _hoisted_34)), [
                      [_directive_dompurify_html, _ctx.manualEsgFormat(row, index)]
                    ])
                  }), 128)),
                  _hoisted_35
                ]))
              : _createCommentVNode("", true),
            (!_ctx.basisModule)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                  _createElementVNode("td", _hoisted_37, [
                    _createElementVNode("ul", _hoisted_38, [
                      _createElementVNode("li", _hoisted_39, [
                        _createElementVNode("h2", null, [
                          _createElementVNode("button", {
                            "aria-controls": 'accordion_' + _ctx.getId,
                            "aria-expanded": this.getContent.readonly,
                            class: "accordion-button"
                          }, _toDisplayString((this.getContent.remarksFieldValue || (_ctx.fileList?.length > 0)) ? this.calculatorRemarksFilesAccordion : this.calculatorNoRemarksFilesAccordion), 9, _hoisted_40)
                        ]),
                        _createElementVNode("div", {
                          id: 'accordion_' + _ctx.getId,
                          "aria-hidden": !this.getContent.readonly,
                          class: "accordion-content"
                        }, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(this.getContent.scope3CategoryLabel), 1)
                              ]),
                              _createElementVNode("p", null, _toDisplayString(this.asContentfulString(this.getContent.scope3CategorySelection ?? '')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(this.getContent.remarksFieldLabel), 1)
                              ]),
                              _withDirectives(_createElementVNode("p", null, null, 512), [
                                [_directive_dompurify_html, this.getContent.remarksFieldValue]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.attachedFiles), 1)
                              ]),
                              (_ctx.fileList)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_46, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (file, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: file?.fileName
                                      }, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.openFile(index))
                                        }, _toDisplayString(file?.fileName), 9, _hoisted_47)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 8, _hoisted_41)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.isCopy(this.getContent) ? 'marked-as-copy' : '')
                  }, null, 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_2)
      ]),
      (_ctx.confirmDeleteModel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("h2", _hoisted_51, [
                  _createVNode(_component_SimpleText, { "text-key": "genericcalculation.deleteModalTitle" })
                ]),
                _createElementVNode("button", {
                  "aria-label": "Luk",
                  class: "modal-close button button-unstyled",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmDeleteModel = false))
                }, _hoisted_53)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("h5", null, [
                  _createVNode(_component_SimpleText, { "text-key": "genericcalculation.deleteModalText1" })
                ]),
                _hoisted_55,
                _createTextVNode(" " + _toDisplayString(_ctx.calculationName) + " ", 1),
                _hoisted_56,
                _createElementVNode("p", null, [
                  _createVNode(_component_SimpleText, { "text-key": "genericcalculation.deleteModalText2" })
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  class: "button button-primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteCalculation()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "genericcalculation.deleteModalButton1" })
                ]),
                _createElementVNode("button", {
                  class: "button button-secondary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmDeleteModel = false))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "genericcalculation.deleteModalButton2" })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.confirmDeleteModel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58))
        : _createCommentVNode("", true)
    ])
  ], 2))
}